import { css } from '@emotion/react';
import React from 'react';

import { TributeDef, validateTribute } from '@mythos/game/GameModel';
import { UIColorPalette } from './ColorPalette';
import TributeCardView from './TributeCardView';

const DefaultTribute: TributeDef = {
  module: 'core',
  defID: 'debug_tribute',
  name: 'Grow Bounty',
  subtitle: 'Derion, God of Bounty',
  imageName: 'TributeArtGrowBounty',
  tokens: 1,
  function: 'ObtainCard',
  params: 'Derion',
};

const LOCAL_STORAGE_KEY = 'debug_tribute';

export default function TributeDebugPage() {
  const [tribute, setTribute] = React.useState<TributeDef>(() => {
    const localTribute = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (localTribute) {
      try {
        const parsedTribute = JSON.parse(localTribute);
        validateTribute(parsedTribute);
        return parsedTribute;
      } catch (e) {}
    }
    return DefaultTribute;
  });
  const [tributeText, setTributeText] = React.useState<string>(() =>
    JSON.stringify(tribute, null, 2),
  );

  return (
    <div css={TributeDebugStyles.container}>
      <div css={TributeDebugStyles.previewContainer}>
        <div
          style={{
            zoom: 4,
          }}
        >
          <TributeCardView card={tribute} />
        </div>
        <div
          style={{
            zoom: 2,
          }}
        >
          <TributeCardView card={tribute} />
        </div>
        <div
          style={{
            zoom: 1,
          }}
        >
          <TributeCardView card={tribute} />
        </div>
      </div>
      <div css={TributeDebugStyles.controlsContainer}>
        <textarea
          style={{
            width: '100%',
            height: '100%',
          }}
          value={tributeText}
          onChange={(e) => {
            setTributeText(e.target.value);

            try {
              const newTribute = JSON.parse(e.target.value);

              validateTribute(newTribute);

              setTribute(newTribute);
              localStorage.setItem(
                LOCAL_STORAGE_KEY,
                JSON.stringify(newTribute, null, 2),
              );
            } catch (e) {}
          }}
        />
      </div>
    </div>
  );
}

const TributeDebugStyles = {
  container: css({
    display: 'flex',
    flexDirection: 'row',
    padding: 5,
  }),
  previewContainer: css({
    display: 'flex',
    flexDirection: 'row',
    gap: 2,
  }),
  controlsContainer: css({
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 10,

    backgroundColor: UIColorPalette.cardDebugPageTextAreaBG,
    minWidth: 200,
  }),
};
